export const FILE_TYPES = {
  TFU: 'TFU',
  MGE: 'MGE',
};
